import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"email\"><path fill=\"#37F\" fill-rule=\"nonzero\" d=\"m7.005 6.722 5.904-2.296a.298.298 0 0 0 .19-.278V3.001a.596.596 0 0 0-.596-.596H1.5A.596.596 0 0 0 .905 3v1.41a.3.3 0 0 0 .194.281L6.58 6.725a.6.6 0 0 0 .425-.003ZM6.55 7.818 1.308 5.86a.298.298 0 0 0-.402.279v5.04c0 .329.267.596.597.596h11c.33 0 .596-.267.596-.597V5.823a.298.298 0 0 0-.409-.278L6.98 7.813a.596.596 0 0 1-.43.005Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol